import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../lib/api";

export const useDeletePost = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, kind = "draft" }: { id: string; kind?: "draft" | "published" }) =>
      kind === "published" ? api.drafts.delPublished(id) : api.drafts.del(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["drafts"] });
      qc.invalidateQueries({ queryKey: ["scheduled"] });
      qc.invalidateQueries({ queryKey: ["published"] });
    },
  });
};
